import * as React from "react"
import TextField from "material-ui/TextField"
import Dialog from "material-ui/Dialog"
import FlatButton from "material-ui/FlatButton"
import SelectField from "material-ui/SelectField"
import MenuItem from "material-ui/MenuItem"
import strings from "../../localization/strings"
import autobind from "class-autobind"
import { IEmployeeNotificationSettings, EEmployeeNotificationTypes, ENotifyMethods } from "../../models"
import * as notifyHelper from "../../helpers/notifyHelper"
import { EnumValues } from "enum-values"
import NotifyMethodsChip from "./notifyMethodsChip/NotifyMethodsChip"
import { red500 } from "material-ui/styles/colors"
interface IProps {
  existingNotifications: IEmployeeNotificationSettings[]
  editNotification: IEmployeeNotificationSettings
  handleClose(): void
  handleAdd(notification: IEmployeeNotificationSettings): void
  handleUpdate(notification: IEmployeeNotificationSettings): void
}
interface IState {
  notifyType: EEmployeeNotificationTypes
  errorNotifyType: string
  notifyMethods: ENotifyMethods[]
  errorNotifyMethods: string
  description: string
  milesToJob: string
  errorDuplicated: string
}

export default class AddEmployeeNotificationSettingDialog extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      notifyType: props.editNotification ? props.editNotification.NotificationType : null,
      errorNotifyType: "",
      notifyMethods: props.editNotification ? notifyHelper.getNotifyMethods(props.editNotification.SendEmailNotifications, props.editNotification.SendPushNotifications, props.editNotification.SendSmsNotifications, props.editNotification.SendAppNotifications) : [],
      errorNotifyMethods: "",
      description: props.editNotification ? props.editNotification.Description : "",
      milesToJob: props.editNotification && props.editNotification.MilesToJob ? String(props.editNotification.MilesToJob) : null,
      errorDuplicated: ""
    }
    autobind(this)
  }

  handleSave() {
    if (!this.checkValidate()) return
    const notification: IEmployeeNotificationSettings = {
      NotificationType: this.state.notifyType,
      SendEmailNotifications: this.state.notifyMethods.includes(ENotifyMethods.Email),
      SendPushNotifications: this.state.notifyMethods.includes(ENotifyMethods.Push),
      SendSmsNotifications: this.state.notifyMethods.includes(ENotifyMethods.Sms),
      SendAppNotifications: this.state.notifyMethods.includes(ENotifyMethods.App),
      Description: this.state.description
    }
    if (this.state.notifyType === EEmployeeNotificationTypes.NewJobShift) {
      notification.MilesToJob = this.state.milesToJob ? Number(this.state.milesToJob) : null
    }
    this.props.editNotification ? this.props.handleUpdate(notification) : this.props.handleAdd(notification)
  }

  checkValidate() {
    let isValidate = true
    if (this.state.notifyType === null) {
      this.setState({ errorNotifyType: strings.This_field_is_required })
      isValidate = false
    }
    else {
      this.setState({ errorNotifyType: "" })
    }

    if (this.state.notifyMethods.length === 0) {
      this.setState({ errorNotifyMethods: strings.This_field_is_required })
      isValidate = false
    }
    else {
      this.setState({ errorNotifyMethods: "" })
    }

    if (this.state.notifyType !== null && this.state.notifyMethods.length > 0) {
      const existingNotifications = this.props.existingNotifications.filter(item =>
        this.props.editNotification ?
          item.NotificationType !== this.props.editNotification.NotificationType ||
          item.SendAppNotifications !== this.props.editNotification.SendAppNotifications ||
          item.SendEmailNotifications !== this.props.editNotification.SendEmailNotifications ||
          item.SendSmsNotifications !== this.props.editNotification.SendSmsNotifications ||
          item.SendPushNotifications !== this.props.editNotification.SendPushNotifications :
          true
      )
      const sendEmail = this.state.notifyMethods.includes(ENotifyMethods.Email)
      const sendPush = this.state.notifyMethods.includes(ENotifyMethods.Push)
      const sendSms = this.state.notifyMethods.includes(ENotifyMethods.Sms)
      const sendApp = this.state.notifyMethods.includes(ENotifyMethods.App)
      const duplicatedNotification = existingNotifications.find(item =>
        item.NotificationType === this.state.notifyType &&
        item.SendEmailNotifications === sendEmail &&
        item.SendPushNotifications === sendPush &&
        item.SendSmsNotifications === sendSms &&
        item.SendAppNotifications === sendApp
      )

      if (duplicatedNotification) {
        this.setState({ errorDuplicated: strings.This_Notification_is_duplicated })
        isValidate = false
      }
      else {
        this.setState({ errorDuplicated: "" })
      }
    }
    else {
      this.setState({ errorDuplicated: "" })
    }

    return isValidate;
  }

  render() {
    return (
      <Dialog
        open
        title={this.props.editNotification ? strings.Edit_Notification : strings.Add_Notification}
        titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
        actions={[
          <span style={{ fontSize: 19, marginRight: 40, color: red500 }}>
            {this.state.errorDuplicated}
          </span>,
          <FlatButton
            label={strings.CANCEL}
            secondary
            onTouchTap={this.props.handleClose}
          />,
          <FlatButton
            label={strings.SAVE}
            primary
            onTouchTap={this.handleSave}
          />
        ]}
      >
        <hr />
        <div style={{ paddingLeft: 15, paddingRight: 15 }}>
          <SelectField
            floatingLabelText={strings.Notification_Type}
            value={this.state.notifyType}
            onChange={(event, index, value) => this.setState({ notifyType: value }, () => this.checkValidate())}
            errorText={this.state.errorNotifyType}
            errorStyle={{ position: "absolute", top: 70 }}
          >
            {(EnumValues.getValues(EEmployeeNotificationTypes) as EEmployeeNotificationTypes[])
              .filter(i => !this.props.existingNotifications
                .filter(notification => this.props.editNotification ? this.props.editNotification.NotificationType !== notification.NotificationType : true)
                .map(notification => notification.NotificationType)
                .includes(i)
              )
              .map((item, index) =>
                <MenuItem
                  key={index}
                  value={item}
                  primaryText={notifyHelper.getEmployeeNotificationTypeName(item as EEmployeeNotificationTypes)}
                />
              )
            }
          </SelectField>
          <div style={{ marginTop: 15 }}>
            <NotifyMethodsChip
              notifyMethods={this.state.notifyMethods}
              error={this.state.errorNotifyMethods}
              handleChange={notifyMethods => this.setState({ notifyMethods }, () => this.checkValidate())}
            />
          </div>
          {this.state.notifyType === EEmployeeNotificationTypes.NewJobShift &&
            (this.state.notifyMethods.includes(ENotifyMethods.Email) || this.state.notifyMethods.includes(ENotifyMethods.Push) || this.state.notifyMethods.includes(ENotifyMethods.Sms)) &&
            <div>
              <TextField
                floatingLabelText={strings.Miles_To_Job}
                style={{ width: "50%" }}
                value={this.state.milesToJob || ""}
                onChange={(e, value) => {
                  if (!isNaN(Number(e.target.value))) {
                    this.setState({ milesToJob: value })
                  }
                }}
              />
            </div>
          }
          <div>
            <TextField
              floatingLabelText={strings.Description}
              style={{ width: "80%" }}
              value={this.state.description}
              onChange={(e, value) => this.setState({ description: value })}
            />
          </div>
        </div>
      </Dialog>
    )
  }
}